import moment from 'moment/moment';
import {
  // 日期筛选器
  RANGE_TIME as RANGE_TIME_SELECT_FILTER,
  // 发布时间筛选器
  RELEASE_TIME as RELEASE_TIME_SELECT_FILTER,
  // 级联国家筛选器
  REGION as REGION_SELECT_FILTER,
  REGION_EXTEND_TYPE,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';

/**
 * 判断每一个date是否有效（配置的props名字disabledDate 语意刚好是相反的）
 * 这里是禁用当天以后的日期
 * @param date Moment日期对象
 * @return 当前date是否有效
 */
const isValidDate = (date: moment.Moment): boolean => {
  if (!date?.isValid()) return true;
  return date?.isSameOrBefore(moment(), 'day');
};

// 静态筛选器配置，即所有配置相关的都是常量，不需要通过组件props、组件其他state、组件其他变量来决定 可以单独写在一个js文件中
export const STATIC_FILTER_CONFIGS = {
  RANGE_TIME: {
    key: RANGE_TIME_SELECT_FILTER,
    type: RANGE_TIME_SELECT_FILTER,
    visible: 1,
    disabled: false,
    disabledDate: isValidDate,
    calendarType: 'date',
    autoRange: {
      timeType: 'date',
      length: 0,
    },
    startOfWeek: 2,
    showSelectType: false,
    showShortcut: false,
  },
  RELEASE_TIME: {
    key: RELEASE_TIME_SELECT_FILTER,
    type: RANGE_TIME_SELECT_FILTER,
    visible: 1,
    disabled: false,
    disabledDate: { date: isValidDate },
    calendarType: 'date',
    showSelectType: false,
    showShortcut: false,
  },
  REGION: {
    key: REGION_SELECT_FILTER,
    type: REGION_SELECT_FILTER,
    extendFilterType: REGION_EXTEND_TYPE.common,
    visible: 1,
    disabled: false,
    disableNoChina: true,
    // "popularList": [
    //   "br",
    //   "mx",
    //   "ru",
    //   "tr",
    //   "us"
    // ],
    options: [],
  },
};

// 各个筛选器组件UI渲染需要的value
export const DEFAULT_FORM_VALUE = {
  [RANGE_TIME_SELECT_FILTER]: {
    type: 'date',
    value: [moment(), moment()],
  },
  [RELEASE_TIME_SELECT_FILTER]: {
    value: ['', ''],
  },
  [REGION_SELECT_FILTER]: {
    type: 'market',
    regions: [],
    markets: ['global'],
  },
};
